import ArticleParagraph from './ArticleParagraph';

export default ArticleParagraph;
